import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "amount", "prefix", "suffix", "amountGroup"]

  connect() {
    this.sync()
  }

  sync() {
    const value = this.selectTarget.value
    const isBlank = value === ""
    const isPercentage = ["cost_plus_percentage", "base_plus_percentage"].includes(value)

    this.amountTarget.disabled = isBlank
    this.amountGroupTarget.hidden = isBlank

    this.prefixTargets.forEach((element) => {
      element.hidden = isBlank || isPercentage
    })

    this.suffixTargets.forEach((element) => {
      element.hidden = isBlank || !isPercentage
    })
  }
}
